import styled from '@emotion/styled';
import { Modal } from '@hotjar/hotsauce';

const VideoFrame = styled.iframe`
  border: none;
  width: 100%;
  height: 400px;
  display: block;
`;

const ModalBody = styled(Modal.Body)`
  padding: 0;
  height: 400px;
`;

export interface VideoModalProps {
  isOpen: boolean;
  closeModal: () => void;
  videoUrl: string;
  title: string;
  contentLabel: string;
  description?: string;
}

export const VideoModal = ({
  isOpen,
  closeModal,
  videoUrl,
  title,
  description,
  contentLabel,
}: VideoModalProps): JSX.Element => {
  return (
    <Modal isOpen={isOpen} onClose={closeModal} size="m" contentLabel={contentLabel}>
      <Modal.Header title={title} subtitle={description} />
      <ModalBody>
        <VideoFrame src={videoUrl} title={title} allowFullScreen />
      </ModalBody>
    </Modal>
  );
};
